import { useMemo } from 'react';

import FormInput from './PrepFormInput';
import FormSelect from './PrepFormSelect';

function Step1_PrepForm({ destinationLocations, formData, onDataChange, prepScrapReasons }) {
    const handleDataChange = (e) => {
        const { name, value } = e.target;
        onDataChange((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleLocationChange = (e) => {
        const { value } = e.target;
        const selectedLocation = destinationLocations.find((loc) => loc.value === Number(value));
        onDataChange((prevData) => ({
            ...prevData,
            moveToLocation: value,
            moveToLocationName: selectedLocation?.label || '',
        }));
    };

    const errors = useMemo(() => {
        const newErrors = {};
        if (!!formData?.numRPCs && parseInt(formData?.numRPCs, 10) <= 0) {
            newErrors.numRPCs = 'Value must be greater than zero';
        }
        if (!!formData?.rpcsPerPallet && parseInt(formData?.rpcsPerPallet, 10) <= 0) {
            newErrors.rpcsPerPallet = 'Value must be greater than zero';
        }
        if (!!formData?.unitsPerRPC && parseInt(formData?.unitsPerRPC, 10) <= 0) {
            newErrors.unitsPerRPC = 'Value must be greater than zero';
        }
        return newErrors;
    }, [formData]);

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
            <FormInput
                label="Number of RPCs"
                name="numRPCs"
                type="number"
                required
                value={formData?.numRPCs || ''}
                onChange={handleDataChange}
                error={errors.numRPCs}
                tooltip="Enter the total number of Returnable Plastic Containers needed for this lot."
            />
            <FormInput
                label="Units per RPC"
                name="unitsPerRPC"
                type="number"
                required
                value={formData?.unitsPerRPC || ''}
                onChange={handleDataChange}
                error={errors.unitsPerRPC}
                tooltip="Enter the number of individual units to be placed into each RPC."
            />
            <FormInput
                label="Loose Units"
                name="looseUnits"
                type="number"
                value={formData?.looseUnits || ''}
                onChange={handleDataChange}
                tooltip="Enter the number of individual units to be prepped outside of RPCs."
            />
            <FormInput
                label="Scrap Units"
                name="scrapUnits"
                type="number"
                value={formData?.scrapUnits || ''}
                onChange={handleDataChange}
                tooltip="Enter the number of units that cannot be used (damaged, expired, etc.)."
            />
            <FormSelect
                label="Scrap Reason"
                name="scrapReason"
                required
                value={formData?.scrapReason || ''}
                onChange={handleDataChange}
                options={prepScrapReasons}
                disabled={!formData?.scrapUnits || parseInt(formData.scrapUnits, 10) === 0}
                tooltip="Select the reason for scrapping units."
            />
            <FormSelect
                label="Move to Location"
                name="moveToLocation"
                required
                value={formData?.moveToLocation || ''}
                onChange={handleLocationChange}
                options={destinationLocations}
                tooltip="Select the destination location for the newly prepped RPCs."
            />
            <FormInput
                label="RPCs per pallet"
                name="rpcsPerPallet"
                type="number"
                required
                value={formData?.rpcsPerPallet || ''}
                onChange={handleDataChange}
                error={errors.rpcsPerPallet}
                tooltip="Enter the number of RPCs that fit on one pallet."
            />
        </div>
    );
}

export default Step1_PrepForm;
